import { render } from "./DevelopmentVersionView.vue?vue&type=template&id=a53ec33a&scoped=true"
import script from "./DevelopmentVersionView.vue?vue&type=script&lang=js"
export * from "./DevelopmentVersionView.vue?vue&type=script&lang=js"

import "./DevelopmentVersionView.vue?vue&type=style&index=0&id=a53ec33a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a53ec33a"]])

export default __exports__